import React from 'react'
import { AdminPagesTypes, IAdminPage } from '../Interfaces'
import { useReturnCurrentUser } from '../../user/userSlice'
import UnauthorizedBlock from '../../../components/UnauthorizedBlock'

interface IProps {
    page: IAdminPage,
    type: AdminPagesTypes
}

export default function RenderAdminPageContent(props: IProps) {

    const { page, type } = props

    const currentUser = useReturnCurrentUser()

    if (page.isDaemonOnly){
        if (!currentUser.is_daemon){
            return <UnauthorizedBlock />
        }
    }

    switch(type){

        case "base":
            if (page.pageComponents.viewPage){
                return <page.pageComponents.viewPage />
            }
            return <></>

        case "new":
            if (page.pageComponents.newPage){
                return <page.pageComponents.newPage />
            }
            return <></> 

        case "edit":
            if (page.pageComponents.editPage){
                return <page.pageComponents.editPage />
            }
            return <></> 

        case "view":
            if (page.pageComponents.itemViewPage){
                return <page.pageComponents.itemViewPage />
            }
            return <></> 

        default:
            return <div></div>
    }
}